import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { type PlaneCorners, overlayMatrix3d } from './projection.js';

/**
 * Lives inside the `<Canvas>` and reports the CSS transform that registers the
 * DOM tap overlay with the board as the camera currently sees it. Reading the
 * live camera (not a constant) keeps the grid on the board when the canvas
 * resizes or the player zooms. `onChange` fires only when the matrix changes,
 * so a steady frame costs four projections and a string compare.
 */
export function ProjectionReporter({
  plane,
  onChange,
}: {
  plane: PlaneCorners;
  onChange: (matrix3d: string) => void;
}) {
  const camera = useThree((s) => s.camera);
  const size = useThree((s) => s.size);
  const last = useRef('');
  useFrame(() => {
    camera.updateMatrixWorld();
    const m = overlayMatrix3d(camera, size, plane);
    if (m !== null && m !== last.current) {
      last.current = m;
      onChange(m);
    }
  });
  return null;
}
